<template>
  <div>
    <!-- File Info Dialog -->
    <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t('core.file_detail')"
      :width="$store.localeLanguage==='zh'?520:600" :default-cancel="false" @close="closeDialog">
      <ul class="item-descr-list allow-user-select">
        <li>
          <span class="item-descr-tit">
            <label>{{$t("core.file_name")}}</label>
          </span>
          <span class="item-descr-txt">
            {{filterInfo.name}}
            <a @click="copyText(filterInfo.name)" href="javascript:void(0);" class="js-copy-access-link">
              <i class="copy-icon" :title="$t('core.copy')"></i>
            </a>
          </span>
        </li>
        <li v-if="filterInfo.isFile"><span class="item-descr-tit">{{$t("core.size")}}</span>
          <span class="item-descr-txt">{{filterInfo.sizeText}}&emsp;
            ( {{filterInfo.size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}B )</span>
        </li>
        <li v-if="filterInfo.isFile"><span class="item-descr-tit">{{$t("core.mtime")}}</span><span
            class="item-descr-txt">{{filterInfo.mtime}}</span>
        </li>
        <li>
          <span class="item-descr-tit">{{$t("cos.acl")}}</span>
          <span class="item-descr-txt" :class="{'text-weak':['AccessDenied','Unknown'].includes(filterInfo.acl)}">
            <template v-if="loading">
              <qc-icon type="loading"></qc-icon>
            </template>
            <template v-else>
              {{filterInfo.acl | ObjectAclText}}
              <a @click="onEditObjectAcl"
                v-show="0 && !['AccessDenied','Unknown'].includes(filterInfo.acl) && !$store.IsTegCos"
                href="javascript:void(0);" class="js-copy-access-link">
                <i class="pencil-icon" :title="$t('core.edit')"></i>
              </a>
            </template>
          </span>
        </li>
        <li v-if="filterInfo.isFile || filterInfo.isDirObject">
          <span class="item-descr-tit">{{$t("cos.storage_class")}}</span>
          <span class="item-descr-txt" v-if="!showEditStorageClass">
            {{filterInfo.StorageClass | StorageClassText}}
            <span v-if=" ['ARCHIVE','DEEP_ARCHIVE'].includes(filterInfo.StorageClass) ">
              <span v-if=" filterInfo.restoreInfo.status === 'restored' ">
                ({{$t('core.restore_the_restored_copy_will_be_deleted',
                  { deleteTime: filterInfo.restoreInfo.deleteTime })}})
              </span>
              <span v-else-if=" filterInfo.restoreInfo.status === 'restoring' ">
                ({{$t('core.restore_status_map.restoring')}})
              </span>
              <span v-else>
                <!-- 预留着后期可以加，【留白】 -->
              </span>
            </span>
            <span v-else>
              <a href="javascript:void(0);" class="js-copy-access-link" v-if="bucketInfo.MAZConfig!=='MAZ'"
                @click="showEditStorageClass=true">
                <i class="pencil-icon" :title="$t('core.edit')"></i>
              </a>
            </span>
          </span>
          <span class="item-descr-txt" v-else>
            <qc-radio-group v-model="editStorageClass">
              <qc-radio value="STANDARD" :title="$t('cos.storage_class_map.STANDARD')">
                {{$t('cos.storage_class_map.STANDARD')}}</qc-radio>
              <qc-radio value="STANDARD_IA" :title="$t('cos.storage_class_map.STANDARD_IA')">
                {{$t('cos.storage_class_map.STANDARD_IA')}}</qc-radio>
              <br>
              <qc-radio value="ARCHIVE" :title="$t('cos.storage_class_map.ARCHIVE')" style="word-break: normal;"
                v-if="allowCAS">
                {{$t('cos.storage_class_map.ARCHIVE')}}</qc-radio>
              <qc-radio value="DEEP_ARCHIVE" :title="$t('cos.storage_class_map.DEEP_ARCHIVE')" v-if="allowDeepCAS"
                style="word-break: normal;">
                {{$t('cos.storage_class_map.DEEP_ARCHIVE')}}</qc-radio>
            </qc-radio-group>
          </span>
        </li>
        <li v-if="(filterInfo.isFile || filterInfo.isDirObject) && filterInfo.ETag">
          <span class="item-descr-tit">{{$t("cos.ETag")}}</span>
          <span class="item-descr-txt">{{filterInfo.ETag}}</span>
        </li>

        <li v-if="0">
          <span class="item-descr-tit">{{$t("core.file_path")}}</span>
          <span class="item-descr-txt">{{filterInfo.key}}
            <a @click="copyText(filterInfo.key)" href="javascript:void(0);" class="js-copy-access-link">
              <i class="copy-icon" :title="$t('core.copy')"></i>
            </a>
          </span>
        </li>

        <li v-if="filterInfo.isFile">
          <span class="item-descr-tit">{{$t("cos.headers")}}</span>
          <span v-if="filterInfo.xCosHeaderList && filterInfo.xCosHeaderList.length" class="item-descr-txt">
            <span v-for="(headerItem, index) in filterInfo.xCosHeaderList" :key="index">{{headerItem}}<br /></span>
          </span>
          <span v-else-if="loading" class="item-descr-txt">
            <qc-icon type="loading"></qc-icon>
          </span>
          <span v-else class="item-descr-txt">{{$t("core.empty")}}</span>
        </li>

        <!-- <li v-if="filterInfo.isFile || filterInfo.isDirObject">
          <span class="item-descr-tit">{{$t('cos.specified_domain')}}
            <qc-bubble type="dark" :append-to-body="false">
              <qc-icon type="plaint"></qc-icon>
              <template slot="popup">{{$t("cos.tips.specified_domain")}}</template>
            </qc-bubble>
          </span>
          <span class="item-descr-txt">
            <domain-select v-model="domain" :bucket="bucketInfo.Bucket"
            :region="bucketInfo.Region"></domain-select>
          </span>
        </li> -->

        <li v-if="filterInfo.isFile || filterInfo.isDirObject">
          <span class="item-descr-tit">{{$t("cos.object_url")}}</span>
          <span class="item-descr-txt">
            {{filterInfo.objectUrl}}
            <a @click="copyLink2Clipboard(filterInfo.objectUrl)" href="javascript:void(0);" class="js-copy-access-link">
              <i class="copy-icon" :title="$t('core.copy')"></i>
            </a>
          </span>
        </li>

        <li v-if="filterInfo.isFile ">
          <span class="item-descr-tit">{{$t("core.create_temp_link")}}</span>
          <span class="item-descr-txt">
            <a @click="copyLinkOpen" href="javascript:void(0);"
              class="js-copy-access-link">{{$t("core.create_temp_link")}}</a>
          </span>
        </li>
      </ul>

      <div slot="button">
        <div class="justify-grid">
          <div class="col"></div>
          <div class="col">
            <qc-button v-if="showEditStorageClass" type="default" @click="editObject" :title="$t('core.save')">
              {{$t('core.save')}}</qc-button>
            <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">
              {{$t('core.close')}}</qc-button>
          </div>
        </div>
      </div>

    </qc-dialog>
  </div>
</template>

<script>
import {
  tips,
  getInnerProps,
  copyText2Clipboard,
  copyLink2Clipboard,
} from '@/scripts/tools/utils';
import * as cosSdkUtils from '@/scripts/helper/cos/cosSdkUtils';
import handleAcl from '@/scripts/helper/cos/handleAcl';
import cosPure from '@/scripts/helper/cos/cosPure';
import cos from '@/scripts/helper/cos';
import restore from '@/scripts/helper/restoreFiles';

export default {
  components: {
    // domainSelect,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    fileItem: Object,
    bucketInfo: Object,
    allowCAS: Boolean,
    allowDeepCAS: Boolean,
    selectedList: Array,
  },
  data() {
    return {
      loading: true,
      fileInfo: {},
      // 编辑文件
      showEditStorageClass: false,
      editStorageClass: '',
      domain: '',
      // 归档取回的状态及过期时间
      showRestoreInfo: false,
      restoreFileStatus: '',
      restoreFiledeleteTime: '',
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    filterInfo() {
      const { fileInfo } = this;
      if (!fileInfo.name) return {};
      if (!fileInfo.restoreInfo) {
        fileInfo.restoreInfo = {
          status: 'unrestore',
        };
      }
      const isPublic = cosSdkUtils.isPublic(fileInfo.acl);
      return {
        ...fileInfo,
        objectUrl: this.objectUrl,
        isFile: !fileInfo.isDir,
        isPrivate: !isPublic,
      };
    },
    objectUrl() {
      const { Bucket, Region } = this.bucketInfo;
      const domain = cos.getDefaultBucketDomain({ Bucket, Region });

      let objectUrl = '';
      const { url, key } = this.fileInfo;
      // 若非默认源站域名
      if (this.domain && this.domain !== domain) {
        cosPure.options.Domain = this.domain;
        cosPure.options.Protocol = cos.options.Protocol;
        objectUrl = cosPure.getObjectUrl({
          Bucket, Region, Key: key, Sign: false,
        });
      } else {
        objectUrl = url;
      }
      return objectUrl;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.getFileInfo();
      } else {
        this.showEditStorageClass = false;
        this.editStorageClass = '';
      }
    },
  },
  methods: {
    getFileInfo() {
      this.loading = true;
      this.fileInfo = this.fileItem;

      const { Bucket, Region } = this.bucketInfo;
      const { key, mtime, StorageClass } = this.fileItem;
      const params = { Bucket, Region, Key: key };
      cosPure.headObject(params, (hErr, hData) => {
        const pureContentType = hData?.headers?.['content-type'];
        cos.headObject(params, (headErr, headData) => {
          if (headErr) {
            headData = {
              headers: {
                'last-modified': mtime,
                'x-cos-storage-class': StorageClass,
              },
            };
          }
          const xCosHeaderList = [];
          const xCosIgnoreHeaders = ['x-cos-request-id', 'x-cos-trace-id'];
          const xCosWhiteHeaders = [
            'content-type',
            'content-disposition',
            'content-encoding',
            'cache-control',
            'expires',
            'expires',
          ];
          let xCosRestore = null;
          let restoreInfo = {};
          xCosRestore = headData.headers['x-cos-restore'] || xCosRestore;
          restoreInfo = restore.handleRestoreInfo(xCosRestore);
          if (headData && headData.headers) {
            if (pureContentType) headData.headers['content-type'] = pureContentType;
            Object.keys(headData.headers).forEach(k => {
              const val = headData.headers[k];
              if ((k.startsWith('x-cos-') && xCosIgnoreHeaders.indexOf(k) === -1) || xCosWhiteHeaders.includes(k)) {
                xCosHeaderList.push(`${k}: ${val}`);
              }
            });
          }
          cos.getObjectAcl(params, (err, data) => {
            let objectACL = data && data.ACL;
            if (err) {
              objectACL = err.statusCode === 403 ? 'AccessDenied' : 'Unknown';
            }
            const storageClass = headData.headers['x-cos-storage-class'] || 'STANDARD';
            const fileInfo = {
              ...this.fileItem,
              isDirObject:
                  this.fileItem.isDir && headData && headData.statusCode === 200,
              StorageClass: storageClass,
              acl: objectACL,
              xCosHeaderList,
              restoreInfo,
            };
            this.fileInfo = fileInfo;
            this.editStorageClass = this.fileInfo.StorageClass;
            this.loading = false;
          });
        });
      });
    },
    // 复制文本到粘贴板
    copyText(text) {
      copyText2Clipboard(text);
    },
    // 复制链接到粘贴板
    copyLink2Clipboard(link) {
      copyLink2Clipboard({ link });
    },
    copyLinkOpen() {
      this.$emit('copy-link-open', this.filterInfo);
    },
    editObject() {
      const { fileInfo, editStorageClass } = this;
      if (fileInfo.StorageClass !== editStorageClass) {
        // 单独对归档存储文件判断
        if (fileInfo.StorageClass === 'ARCHIVE') {
          tips.error(this.$t('error.archived_file_not_allow_change'));
          return;
        }
        // 这里的 selectedList 同步对应当前页面下的 list 数组，修改存储类型会修改 list 数组下的选中文件（同名判断）的存储类型
        this.selectedList.forEach(item => {
          if (item.key === fileInfo.key) {
            item.StorageClass = editStorageClass;
          }
        });
        this.editObjectStorageClass();
      }
      this.closeDialog();
    },
    onEditObjectAcl() {
      this.$emit('edit', { type: 'acl', item: this.fileInfo });
      this.closeDialog();
    },
    getObjectAcl(cb) {
      const { Bucket, Region } = this.bucketInfo;
      const { key } = this.fileInfo;
      const params = { Bucket, Region, Key: key };

      cos.getObjectAcl(params, (err, aclData) => {
        if (err) {
          const { error } = err;
          const code = (error && error.Code) || err.code;
          if (code === 'AccessDenied') {
            cb(this.$t('error.no_permission_to_edit_storage_class'));
            return;
          }
          cb(window.lang.err(`error['${code}']`, error));
          return;
        }
        if (!aclData.Owner) {
          cb(this.$t('error.no_permission_to_edit_storage_class'));
          return;
        }

        if (/^tce-.*/.test(aclData.ACL)) {
          aclData.ACL = aclData.ACL.replace(/^tce-/, '');
        }
        const { publicAcl, userAclList } = handleAcl.init(aclData);
        const paramsItem = handleAcl.getParameter(userAclList);
        cb(null, {
          Bucket,
          Region,
          Key: key,
          ACL: publicAcl,
          GrantRead: paramsItem.ReadUinList,
          GrantWrite: paramsItem.WriteUinList,
          GrantReadAcp: paramsItem.ReadAcpUinList,
          GrantWriteAcp: paramsItem.WriteAcpUinList,
          GrantFullControl: paramsItem.FullUinList,
        });
      });
    },
    editObjectStorageClass() {
      const { Bucket, Region } = this.bucketInfo;
      const { key: Key } = this.fileInfo;
      const { editStorageClass: StorageClass } = this;
      const url = cos.getObjectUrl({
        Bucket,
        Region,
        Key,
        Sign: false,
      });
      const CopySource = url.replace(/^https?:\/\//, '');

      this.getObjectAcl((err, aclParams) => {
        if (err) {
          tips.error(err);
          return;
        }

        const params = {
          Bucket,
          Region,
          Key,
          StorageClass,
          CopySource,
        };
        cos.putObjectCopy(params, err1 => {
          if (err1) {
            const { error } = err1;
            const code = (error && error.Code) || err1.code;
            if (code === 'AccessDenied') {
              tips.error(this.$t('error.no_permission_to_edit_storage_class'));
              return;
            }
            tips.error(window.lang.err(`error['${code}']`, error));
            return;
          }

          cos.putObjectAcl(aclParams, err2 => {
            if (err2) {
              const { error } = err2;
              const code = (error && error.Code) || err2.code;
              if (code === 'AccessDenied') {
                tips.error(
                  this.$t('error.no_permission_to_edit_storage_class'),
                );
                return;
              }
              tips.error(window.lang.err(`error['${code}']`, error));
              return;
            }

            tips.success(
              window.lang.t('core.success', {
                msg: window.lang.t('core.setting'),
              }),
            );
          });
        });
      });
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style>
</style>
